"use client";

import type {ComponentType} from "react";
import RedialingRuleToolDetails from "./RedialingRuleToolDetails";
import EvalToolDetails from "./EvalToolDetails";
import UseCaseToolDetails from "./UseCaseToolDetails";
import ScriptToolDetails from "@/components/scripts/presentation/ScriptDetails";
import ToolPresentationDetails, {type ToolDetailsProps} from "./ToolPresentationDetails";

const toolRenderers: ReadonlyMap<string, ComponentType<ToolDetailsProps>> = new Map([
   ["phone_scripts_create", ScriptToolDetails],
   ["use_cases_create", UseCaseToolDetails],
   ["redialing_rules_create", RedialingRuleToolDetails],
   ["redialing_rules_update", RedialingRuleToolDetails],
   ["script_evals_create", EvalToolDetails],
   ["script_evals_update", EvalToolDetails],
   ["script_evals_archive", EvalToolDetails],
   ["script_evals_start_run", EvalToolDetails],
]);

/** Routes tool content independently of approval state and decision controls. */
export default function ToolDetails(props: ToolDetailsProps) {
   const Renderer = toolRenderers.get(props.presentation.toolName) ?? ToolPresentationDetails;
   return <Renderer {...props} />;
}
